import { render, staticRenderFns } from "./gc-data-grid.vue?vue&type=template&id=68b9bad5&"
import script from "./gc-data-grid.vue?vue&type=script&lang=js&"
export * from "./gc-data-grid.vue?vue&type=script&lang=js&"
import style0 from "./gc-data-grid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports